import axios from 'axios'

export const apiCall = axios.create({
  baseURL: '/api/scheduling/v1',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
})
